// Lazy getter to avoid circular dependency with store
let storeModule: typeof import("../store") | null = null;

/**
 * Lazy getter for the store hook.
 * Uses require to avoid circular dependencies at module load time.
 * @returns The useStore hook from the store module
 */
export const getStore = () => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  storeModule ??= require("../store") as typeof import("../store");
  return storeModule.useStore;
};

/**
 * Lazy getter for the clearStore function.
 * Uses require to avoid circular dependencies at module load time.
 * @returns The clearStore function from the store module
 */
export const getClearStore = () => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  storeModule ??= require("../store") as typeof import("../store");
  return storeModule.clearStore;
};
